import moment, { Moment } from "moment-timezone";

import { TemporalValueForString } from "api/generated/model";

type TemporalValueSet<T> = (Omit<TemporalValueForString, "value"> & {
    value: T;
})[];

function getValueOfResourceAt<ID, T>(
    resources: { id: ID; values: TemporalValueSet<T> }[],
    id: ID,
    at: Moment
): T | null {
    const temporalValueSet = resources.find((r) => r.id === id) ?? null;
    if (temporalValueSet === null) {
        return null;
    }
    return getValueAt(temporalValueSet.values, at);
}

function getValueAt<T>(set: TemporalValueSet<T>, at: Moment): T | null {
    return (
        set.find((range) =>
            at.isBetween(
                moment(range.start ?? 0),
                moment(range.end ?? 1e15),
                undefined,
                "[]"
            )
        )?.value ?? null
    );
}

export { getValueOfResourceAt, getValueAt };
